import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "18",
  viewBox: "0 0 14 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M8.08122 18H5.92122V6.48H0.857219V4.608H13.1452V6.48H8.08122V18ZM0.857219 0.863999H13.1452V2.736H0.857219V0.863999Z" }, null, -1)
  ]))]))
}
export default { render: render }